var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBdaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FE5000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5h4.6c1.9 0 3.1 1 3.1 2.5 0 1-.5 1.7-1.4 2.1 1.2.3 1.9 1.2 1.9 2.4 0 1.7-1.3 2.8-3.4 2.8H7V6.5Zm4.3 3.9c.8 0 1.3-.4 1.3-1.1 0-.7-.5-1.1-1.3-1.1H9v2.2h2.3Zm.3 4.1c.9 0 1.4-.4 1.4-1.2 0-.7-.5-1.2-1.4-1.2H9v2.4h2.6Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 1.6,
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdaIcon);
export default __webpack_public_path__ + "static/media/bda-icon.acf2de0cf6fdbb5ad0258c122814bf70.svg";
export { ForwardRef as ReactComponent };